import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";

import { updateAssessment } from "common/services/assessments.service";
import AssessmentForm, {
  assessmentValidationSchema,
  buildAssessmentFormData,
  getAssessmentInitialValues,
} from "./AssessmentForm";

const UpdateAssessment: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchUpdatedData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchUpdatedData, selectedRecord }) => {
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: getAssessmentInitialValues(selectedRecord),
    validationSchema: assessmentValidationSchema,
    onSubmit: async (values) => {
      const formData = buildAssessmentFormData(values, true);

      try {
        setLoading(true);
        await updateAssessment({
          id: selectedRecord.id,
          formData,
        });
        fetchUpdatedData();
        validation.resetForm();
        toggle();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="show-assessment-modal"
      size="xl"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Assessment
      </ModalHeader>
      <AssessmentForm validation={validation} isUpdate loading={loading} toggle={toggle} />
    </Modal>
  );
};

export default UpdateAssessment;
